// extracted by mini-css-extract-plugin
module.exports = {"outer":"Zy8Uw","leftWrapper":"_1ezon","heading":"_11wNi","subHeading":"kWVe5","rightWrapper":"_21F9n"};